export default {
    namespaced: true,
    state: {
        status: false,
        url: ''
    },
    getters: {
        getStatus: state => state.status,
        getUrl: state => state.url
    },
    mutations: {
        setStatus(state, value){
            state.status = value
        },
        setUrl(state, value){
            state.url = value
        }
    }
}
